import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/QualificationsPopupLink';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const QualificationsSearcher = props => {
  const [qualificationIds, setQualificationIds] = useState(props.qualification_ids);
  const [shouldSubmit, setShouldSubmit] = useState(false);

  useEffect(() => {
    if (shouldSubmit) {
      $('form').submit();
    }
  },[shouldSubmit]);

  const url = (() => {
    const path = '/popup/member_qualifications';
    const data = {
      selected_ids: qualificationIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedQualifications => {
    setQualificationIds(selectedQualifications.map(qualification => qualification.id).join(','));
  };

  const onSubmit = () => {
    setShouldSubmit(true);
  };

  const onChangeQualificationIds = event => {
    setQualificationIds(event.target.value);
  };

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.qualifications}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_license')}
        onClosePopup={onClosePopup}
        onSubmit={onSubmit}
        selectedNames={props.input_qualification_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}

      />
      <input type="hidden"
             name="q[license_ids]"
             onChange={onChangeQualificationIds}
             value={qualificationIds}
      />
    </>
  );
};

QualificationsSearcher.propTypes = {
  qualification_ids: PropTypes.string,  // ie. "1,2,3"
  input_qualification_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return (
    <>
      <a className="back select-licence-btn" onClick={props.onClickCloseButton}>他の条件を選択</a>
      <a className="search search-licence-btn" onClick={props.onClickSubmitButton}>この条件で検索</a>
    </>
  );
};

export default QualificationsSearcher;
